import React from "react";
import { Activity } from "lucide-react";

export default function ActivityTimeline({ entries = [] }) {
  if (!entries || entries.length === 0)
    return <div className="text-sm text-gray-500">No activity yet</div>;
  return (
    <ol className="relative border-l border-gray-200 ml-3">
      {entries.map((e, i) => (
        <li key={i} className="mb-5 ml-4">
          <div className="absolute w-3 h-3 bg-brand-500 rounded-full -left-1.5 mt-1.5" />
          <time className="text-xs text-gray-500">{new Date(e.timestamp).toLocaleString()}</time>
          <div className="text-sm">
            <span className="font-semibold capitalize">{e.action.replace(/_/g, " ")}</span>
            {e.user_name ? ` — ${e.user_name}` : ""}
          </div>
          {e.details && <p className="text-xs text-gray-600 mt-0.5">{e.details}</p>}
        </li>
      ))}
    </ol>
  );
}
